import { Card } from 'app/components/ui/Card'
import { Text } from 'app/components/ui/Text'
import { themeEstra } from 'app/styles/themeEstra'
import { formatApiIsoDate } from 'app/utils/date'
import {
  QuotationStatusDictionary,
  statusTextColors,
} from 'app/utils/quotations'
import { PaymentTerms, QuotationRequest } from 'EstraSuppliers'
import React from 'react'
import styled from 'styled-components'
import copyIcon from 'static/icons/copy.svg'
import { Button } from 'app/components/ui/Button'
import { CardListItem } from 'app/components/shared/CardListItem'

interface Props {
  quotation: QuotationRequest
}

const PAYMENT_TERMS: Record<PaymentTerms, string> = {
  '30': '30 gg fine mese data fattura',
  '120': '120 gg fine mese data fattura',
  '60': '60 gg fine mese data fattura',
  '90': '90 gg fine mese data fattura',
  immediato: 'ordine di pagamento immediato',
}

export const QuotationCard: React.FC<Props> = ({
  quotation: {
    description,
    status,
    quotation_status,
    requested_at,
    quotation_completed_at,
    quotation_rda,
    company_name,
    referent_name,
    referent_email,
    activity_code,
    payment_terms,
  },
}) => {
  // Copy the referrer name to the clipboard on button click
  const CopyReferrerEmailToClipboard = () => {
    // Is needed to create a text area as copyng from a text directly is not supported
    const el = document.createElement('textarea')
    el.value = referent_email as string
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
  }

  return (
    <QuotationDetailCard shadow padding={'3rem'} mobilePadding={'2rem'}>
      <Text mb={1} variant='s24' weight='700'>
        DETTAGLI
      </Text>
      <Text
        mb={4}
        variant='s20'
        isItalic
        dangerouslySetInnerHTML={{ __html: description }}
      ></Text>
      {(status || quotation_status) && (
        <CardListItem label={'Stato richiesta'}>
          <Text
            variant='s20'
            color={statusTextColors[quotation_status || status]}
          >
            {QuotationStatusDictionary[quotation_status || status]}
          </Text>
        </CardListItem>
      )}
      {requested_at && (
        <CardListItem label={'Data richiesta'}>
          <Text variant='s20' color={themeEstra.color.primari.grigioEstra}>
            {formatApiIsoDate(requested_at, true, false, ' ·')}
          </Text>
        </CardListItem>
      )}{' '}
      {quotation_completed_at && quotation_status !== 'canceled' && (
        <CardListItem label={'Data approvazione'}>
          <Text variant='s20' color={themeEstra.color.primari.grigioEstra}>
            {formatApiIsoDate(quotation_completed_at, true, false, ' ·')}
          </Text>
        </CardListItem>
      )}
      {quotation_rda && (
        <CardListItem label={'Codice RDA'}>
          <Text variant='s20' color={themeEstra.color.primari.grigioEstra}>
            {quotation_rda}
          </Text>
        </CardListItem>
      )}
      {company_name && (
        <CardListItem label={'Azienda'}>
          <Text variant='s20' color={themeEstra.color.primari.grigioEstra}>
            {company_name}
          </Text>
        </CardListItem>
      )}
      {referent_name && (
        <CardListItem label={'Referente'}>
          <ReferentItemWrapper>
            <Text variant='s20' color={themeEstra.color.primari.grigioEstra}>
              <a href={`mailto:${referent_email}`}>{referent_name}</a>
            </Text>
            <CopyButton
              onClick={CopyReferrerEmailToClipboard}
              variant='trasparente'
            >
              <img src={copyIcon} alt='copy'></img>
            </CopyButton>
          </ReferentItemWrapper>
        </CardListItem>
      )}
      {activity_code && (
        <CardListItem label={'ID Attività'}>
          <Text variant='s20' color={themeEstra.color.primari.grigioEstra}>
            {activity_code}
          </Text>
        </CardListItem>
      )}
      {payment_terms && (
        <CardListItem label={'Pagamento'}>
          <Text variant='s20' color={themeEstra.color.primari.grigioEstra}>
            {payment_terms ? PAYMENT_TERMS[payment_terms] : null}
          </Text>
        </CardListItem>
      )}
      <DocumentsList>
        <Text variant='s20' weight='700' mb={1}>
          Documenti importanti per la fatturazione.
        </Text>
        <Text variant='s20' mb={0.5}>
          <a
            href='https://res.cloudinary.com/estra/image/upload/v1598977565/Estra%20Marketing/docs/Comunicazione_ai_fornitori.pdf'
            target='_blank'
            rel='noopener noreferrer'
          >
            Informazioni per lo split payment
          </a>
        </Text>
        <Text variant='s20'>
          <a
            href='https://res.cloudinary.com/estra/image/upload/v1598977567/Estra%20Marketing/docs/Lettera_fatturazione_elettronica.pdf'
            target='_blank'
            rel='noopener noreferrer'
          >
            Informazioni sulla fatturazione elettronica
          </a>
        </Text>
      </DocumentsList>
    </QuotationDetailCard>
  )
}

const QuotationDetailCard = styled(Card)``

const ReferentItemWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const CopyButton = styled(Button)`
  padding: 0 1rem 0 1rem;
`

const DocumentsList = styled.div`
  margin-top: 3rem;
`
